module.exports = __webpack_public_path__ + "static/media/skola-vizualizacia.3f0ca33c.jpg";